import lodashCloneDeep from 'lodash/cloneDeep';
import { allowedSignalKinds } from '../../constants/allowedSignalKinds';
import { checkMatch } from '../general/checkMatch';
import { getAtomTypeFromNucleus } from '../general/getAtomTypeFromNucleus';
/**
 * Get all DEPT signals from experiments with allowed signal kinds in "signalKindsToInclude".
 *
 * @param {ExperimentsType} experiments1DExtra
 */
export function getSignalsDEPT(experiments1DExtra) {
    // store valid signals from 1D extra experiments, e.g. DEPT, APT
    const _signalsDEPT = {};
    // store valid signals from 2D experiments
    Object.keys(experiments1DExtra)
        .filter((experimentType) => experimentType === 'dept')
        .forEach((experimentType) => experiments1DExtra[experimentType].forEach((_experimentDEPT) => {
        const experimentDEPT = _experimentDEPT;
        const _signals = [];
        const match = experimentDEPT.info.pulseSequence.match(/\d/g);
        if (match) {
            const mode = match.reduce((_mode, digit) => _mode + digit);
            const atomType = getAtomTypeFromNucleus(experimentDEPT.info.nucleus);
            const __signals = experimentDEPT.ranges.values
                .map((range) => range.signals
                .filter((signal) => signal.kind && allowedSignalKinds.includes(signal.kind))
                .map((signal) => {
                return { ...signal, sign: range.absolute > 0 ? 1 : -1 };
            }))
                .flat();
            __signals.forEach((signal) => {
                if (!_signals.some((_signal) => checkMatch(_signal.signal.delta, signal.delta, 0.0))) {
                    _signals.push({
                        experimentType,
                        experimentID: experimentDEPT.id,
                        mode,
                        atomType,
                        signal: lodashCloneDeep(signal),
                    });
                }
            });
            _signalsDEPT[mode] = _signals;
        }
    }));
    return _signalsDEPT;
}
//# sourceMappingURL=getSignalsDEPT.js.map